import { Avatar, Button, Card, CardContent, Grid2, Paper, Table, TableBody, TableCell, TableContainer, TableRow, Typography } from "@mui/material";
import dayjs from "dayjs";
import { EditNoteSharp } from "@mui/icons-material";
import { API_HOST, BE_HOST, FOTO_HOST } from "../../helper/Constant";
import LoadingSkeleton from "../general/LoadingSkeleton";
import { useNavigate } from "react-router-dom";

function DetailSantri({ dataSantri, dataTujuan, fileFoto }) {
    const navigate = useNavigate(); // Initialize the navigate function
    if (!dataSantri || !dataSantri.nama) {
        return (
            <Card>
                <CardContent>
                    <LoadingSkeleton size={5}></LoadingSkeleton>
                </CardContent>
            </Card>
        )
    }
    if (fileFoto) {
        fileFoto = FOTO_HOST + fileFoto;
    }
    const CalculateUmur = () => {
        const parsedDate = dayjs(dataSantri.tanggal_lahir);
        const birthYear = parsedDate.year();
        const currentYear = dayjs().year();
        return (currentYear - birthYear) + " Tahun";
    }
    const FormatDate = (dateTime) => {
        return dayjs(dateTime).format("YYYY-MM-DD");
    }
    return (
        <>
            <Card>
                <CardContent>
                    <Grid2 container columns={24}>
                        <Grid2 color={"white"} sx={{ backgroundColor: "#e96726", minHeight: "20vh", padding: "10px" }} size={12}>
                            <Typography variant="h4" sx={{ textAlign: "left" }} component="div">
                                {dataSantri.nama}
                            </Typography>
                            <Typography variant="h5" sx={{ textAlign: "left" }} component="div">
                                {dataTujuan.jenjang_tujuan}
                            </Typography>

                        </Grid2>
                        <Grid2 size={12} sx={{ backgroundColor: "#e96726", minHeight: "20vh", display: "flex", justifyContent: "center", alignItems: "center", textAlign: "center" }}>
                            <Avatar src={fileFoto} sx={{ width: "120px", height: "120px" }} variant="square"></Avatar>
                        </Grid2>

                        <Grid2 size={12} sx={{ border: "1px solid #DCE4C9", display: "flex", alignItems: "center", justifyContent: "center", minHeight: "10vh" }}>
                            <b>{CalculateUmur()}</b>
                        </Grid2>
                        <Grid2 size={12} sx={{ border: "1px solid #DCE4C9", display: "flex", alignItems: "center", justifyContent: "center", minHeight: "10vh" }}>
                            <b>Cita2: {dataSantri.cita_cita}</b>
                        </Grid2>
                        <Grid2 size={24}>
                            <TableContainer component={Paper}>
                                <Table>
                                    <TableBody>
                                        <TableRow>
                                            <TableCell component="th" scope="row">
                                                Nama
                                            </TableCell>
                                            <TableCell align="left">
                                                : <b>{dataSantri.nama}</b>
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell component="th" scope="row">
                                                No. Pendaftaran
                                            </TableCell>
                                            <TableCell align="left">
                                                : <b>{dataSantri.no_daftar}</b>
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell component="th" scope="row">
                                                Jenis Kelamin
                                            </TableCell>
                                            <TableCell align="left">
                                                : <b>{dataSantri.jenis_kelamin}</b>
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell component="th" scope="row">
                                                Jenjang
                                            </TableCell>
                                            <TableCell align="left">
                                                : <b>{dataTujuan.jenjang_tujuan}</b>
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell component="th" scope="row">
                                                Kelas
                                            </TableCell>
                                            <TableCell align="left">
                                                : <b>{dataTujuan.kelas_tujuan}</b>
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell component="th" scope="row">
                                                Tgl. Pendaftaran
                                            </TableCell>
                                            <TableCell align="left">
                                                : <b>{FormatDate(dataSantri.created_at)}</b>
                                            </TableCell>
                                        </TableRow>
                                    </TableBody>
                                </Table>
                            </TableContainer>
                            <Button sx={{ mt: 5, backgroundColor: "#e96726" }} onClick={() => {
                                navigate('/editdata/' + dataSantri.id);
                            }} variant="contained" startIcon={<EditNoteSharp></EditNoteSharp>} color="primary" fullWidth>Ubah Data Pendaftaran</Button>
                        </Grid2>
                    </Grid2>
                </CardContent>
            </Card>
        </>
    )
}

export default DetailSantri;